import { Options } from 'highcharts/highstock';

export const getBaseOptions = () => {
    const options: Options = {
        plotOptions: {
            series: {
                states: {
                    inactive: {
                        enabled: false,
                    },
                },
            },
        },
        time: {
            // Note: this (along with getDateWithTime, which last reading is using) uses the *browser's* local time, not the device.
            // It might make more sense for larger customers if we use device time. We would need to use its geodata to get its
            // timezone offset and pass that through to here, as well as anywhere else that deals with time. Which sounds like a pain, so I'm leaving this here.
            timezoneOffset: new Date().getTimezoneOffset(), // highcharts accepts timestamp -> needs to convert to local time
            useUTC: false,
        },
        boost: {
            enabled: false,
        },
        legend: {
            enabled: true,
            align: 'center',
            layout: 'horizontal',
            itemDistance: 10,
        },
        title: {
            text: '',
        },
        xAxis: {
            type: 'datetime',
            ordinal: false,
        },
        yAxis: [
            {
                id: 'percent',
                plotLines: [
                    {
                        zIndex: 0,
                        color: 'orange',
                        dashStyle: 'LongDash',
                        value: 31,
                        width: 2,
                    },
                ],
                title: {
                    text: null,
                },
                labels: {
                    format: '{value}%',
                    x: 20,
                },
                height: '40%',
                floor: 0,
                min: 0,
                max: 100,
                showFirstLabel: false,
                showLastLabel: false,
            },
            {
                id: 'telemetry',
                title: {
                    text: null,
                },
                labels: {
                    format: '{value}',
                    x: -20,
                },
                height: '40%',
                floor: 0,
                showFirstLabel: false,
                showLastLabel: false,
                opposite: true,
            },
            {
                id: 'gallons',
                title: {
                    text: null,
                },
                labels: {
                    format: '{value} Gal',
                    x: 30,
                },
                top: '65%',
                height: '35%',
                lineWidth: 2,
                showFirstLabel: false,
                showLastLabel: false,
            },
            {
                id: 'hdd',
                labels: {
                    format: '{value}',
                    x: -30,
                },
                allowDecimals: false,
                title: {
                    text: null,
                },
                top: '75%',
                height: '25%',
                lineWidth: 2,
                opposite: true,
                showFirstLabel: false,
                showLastLabel: false,
            },
            {
                id: 'min temp',
                labels: {
                    format: '{value}°F',
                    x: -30,
                },
                title: {
                    text: null,
                },
                top: '50%',
                height: '25%',
                lineWidth: 2,
                opposite: true,
                showFirstLabel: false,
                showLastLabel: false,
            },
        ],
        rangeSelector: {
            selected: 0,
            buttonSpacing: 5,
            buttonTheme: {
                width: 80,
            },
            enabled: true,
            buttons: [
                {
                    type: 'month',
                    count: 1,
                    text: '1 month',
                },
                {
                    type: 'month',
                    count: 3,
                    text: '3 months',
                },
                {
                    type: 'month',
                    count: 6,
                    text: '6 months',
                },
                {
                    type: 'ytd',
                    text: 'Year to date',
                },
                {
                    type: 'year',
                    count: 1,
                    text: '1 year',
                },
                {
                    type: 'year',
                    count: 2,
                    text: '2 years',
                },
                {
                    type: 'all',
                    text: 'Show All',
                },
            ],
        },
        navigator: {
            margin: 0,
            enabled: true,
            maskFill: 'rgba(204,204,204, .3)',
            outlineColor: '#eee',
            series: {
                gapSize: 2,
                color: '#999999',
            },
        },
        tooltip: {
            shared: false,
            valueDecimals: 1,
            split: false,
            xDateFormat: '%b %e %l:%M %p',
        },
        series: [],
        credits: {
            enabled: false,
        },
    };
    return options;
};
